import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-afc4f1ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-proportion" }

import { ref, onMounted, shallowRef, onUnmounted, computed, watch } from 'vue'
import * as echarts from 'echarts'
import { storeToRefs } from 'pinia'
import { useHomeDataStore } from '@/pinia/useHomeDataStore'
import TitleCpn from '../../../Title/TitleCpn.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationProportion',
  setup(__props) {

const homeDataStore = useHomeDataStore()
const { data } = storeToRefs(homeDataStore)
const chartRef = ref()
const myChart = shallowRef()

const option = computed(() => {
    return {
        grid: {
            // width:315 //调整折线图的宽度
            top: 30,
            left: 60,
            right: 20,
            bottom: 30
        },
        dataZoom: [
            {
                type: 'inside',
                start: 60,
                end: 100
            },
            {
                show: false,
                start: 60,
                end: 100
            }
        ],
        xAxis: {
            type: "category",
            boundaryGap: false,
            data: data.value?.right3.xData || [],
            axisLabel: {
                show: true,
                interval: 0, //横轴信息全部显示
                textStyle: {
                    color: "#A2B0B8",
                    fontSize: '1.4rem'
                }
            }
        },
        yAxis: {
            axisTick: {
                show: false //轴刻度不显示
            },
            max: 'dataMax',
            min: 0,
            // 改变y轴颜色
            axisLine: {
                lineStyle: {
                    width: 0
                }
            },
            // 轴网格
            splitLine: {
                show: true,
                lineStyle: {
                    color: "#ffffff",
                    width: 0.3,
                    type: "dashed"
                }
            },
            //坐标轴文字样式
            axisLabel: {
                show: true,
                textStyle: {
                    color: "#A2B0B8",
                    fontSize: '1.4rem'
                }
            }
        },
        series: [
            {
                name: '发明授权趋势',
                type: 'line',
                areaStyle: {
                    color: "#0DB896",
                    opacity: 1

                },
                symbol: '',
                label: {
                    normal: {
                        show: true,
                        position: 'top',
                        textStyle: {
                            color: '#ffffff',
                            fontSize: '1rem'
                        }
                    }
                },
                lineStyle: {
                    normal: {
                        width: 0 //折线宽度
                    }

                },
                itemStyle: {
                    color: 'rgba(0, 0, 0, 0)',

                },
                data: data.value?.right3.yDate || [],
            }
        ]
    }
})

onMounted(() => {
    setTimeout(() => {
        createChart()
    }, 500)
})

onMounted(() => {
    window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})

const handleResize = () => {
    myChart.value?.resize()
}

const createChart = async () => {
    myChart.value = echarts.init(chartRef.value);
    myChart.value.setOption(option.value);
}

watch(
    option,
    () => { myChart.value?.setOption(option.value) },
    {immediate: true}
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleCpn, { title: "发明授权趋势" }),
    _createElementVNode("div", {
      class: "chart-container",
      ref_key: "chartRef",
      ref: chartRef
    }, null, 512)
  ]))
}
}

})